// @ts-nocheck
/* eslint-disable react/destructuring-assignment */
/* eslint-disable arrow-body-style */
/* eslint-disable no-case-declarations */
/* eslint-disable camelcase */
/* eslint-disable no-param-reassign */
import React, { useRef, useMemo } from 'react';
import {
  Element, ClassificationValue, DynamicValue, DynamicElement,
} from '@fulcrumapp/fulcrum-core';
import { styled } from '@mui/material/styles';
import { Box, Collapse } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';
import ClassificationsetField from './classificationset-field';
import TextField from './text-field';
import TaskLinkField from '../../tasks/fields/task-link-field';
import NumberField from './number-field';
import DateField from './date-field';
import AddressField from './address-field';
import withDataEvents, { getDateValue } from '../../record-editor/data-event-handler/with-data-events';
import PhotoField from './ita-photo-field';
import ProjectField from './project-field';
import ChecklistField from '../../tasks/checklist';
import { photoFieldHelper, castItem } from './helpers/ita-photo-field-helper';
import { Address, Image } from './media-props';
import { useApp } from '../../hooks/use-app';
import { CustomAccordion } from '../../shared/material_components';
import { LinkedRecord } from '../../shared/material_components/linked-cell';
import TaskLink from '../../tasks/fields/task-link';
import Repeat from '../../tasks/fields/repeat';
import IssueLink from '../../issues/issue-link';
import RecordLink from './record-link/record-link';
import { SystemAppData } from '../../hooks/use-system-app';
import ApplinkField from '../../tasks/fields/app-link-field';
import { ParentRecordState } from '../../record-editor';
import { getLinkagePickerItem, StatusColorMap } from './helpers/editor-fields-helper';
import LocationField from './location-field';
import TabbedSectionGroup from '../../shared/material_components/tabbed-section-group';
import { LiteElement } from '../../tasks/types';
import EditorTopBar from './editor-top-bar';
import { RecordTerms, Record } from '../record.types';
import CombinedCreatedField from './combined-created-field';
import ChoiceField, { IValue } from './choice-field';
import ITAAssignmentField from './ita-assignment-field';

interface Props {
  formData?: SystemAppData;
  record: Record<any>;
  fields: Array<Element>;
  errorsFields?: Array<string>;
  onChange: <T>(field: any, value: T) => void;
  openRecordInEditor: (
    record?: Record<any>,
    formData?: SystemAppData,
    shouldLinkToParent?: boolean,
  ) => void;
  linkSelectedRecords: (key: string, taskIDs: any[], issueRecordToLink?: Record<any>) => void;
  terminology?: RecordTerms,
  handleClose?: () => void;
}

const FieldContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'topBarField',
})<{ topBarField?: boolean }>(({ topBarField, theme }) => ({
  padding: topBarField
    ? `0 0 ${theme.spacing(1.5)} 0`
    : `${theme.spacing(1.5)} 0`,
}));

const appLinkFieldId = 'x758';

const topBarFieldGroup = ['StatusField'];

const isTopBarField = (elementType: string): boolean => topBarFieldGroup
  .some((fieldType: string) => {
    return fieldType === elementType;
  });

const linkedRecordView = (data_name: string) => {
  switch (data_name) {
    case 'linked_tasks':
      return (record: LinkedRecord, onClick: (linkedRecord: LinkedRecord) => void) => (
        <TaskLink key={record.id} task={record} onClick={onClick} />
      );
    case 'issues':
      return (record: LinkedRecord, onClick: (linkedRecord: LinkedRecord) => void) => (
        <IssueLink key={record.id} issue={record} onClick={onClick} />
      );
    default:
      return (record: LinkedRecord, onClick: (linkedRecord: LinkedRecord) => void) => (
        <RecordLink key={record.id} record={record} onClick={onClick} />
      );
  }
};

const EditorFields = ({
  formData, record, fields, errorsFields = [], onChange, openRecordInEditor,
  linkSelectedRecords, terminology = { createdVerb: 'created' },
  handleClose,
}: Props) => {
  const app = useApp();
  const apiToken = app?.api?.token;
  const isError = useMemo(() => !!errorsFields?.length, [errorsFields]);
  const myRef = useRef<null | HTMLDivElement>(null);
  const dateValue = getDateValue(fields, record);

  const handleError = (label: string) => {
    if (errorsFields?.includes(label)) {
      myRef.current?.scrollIntoView({ behavior: 'smooth' });
    }
    return errorsFields?.includes(label);
  };

  const handleRef = (field: Element) => {
    if (field.required && isError && !record.form_values[field.key]) {
      return myRef;
    }
    return null;
  };

  const renderFields = (elements: Element[]): Element[] => {
    const topBarElements: Array<Element | LiteElement> = [];
    const renderedElements: Array<Element | LiteElement> = [];
    const tabbedSections: Array<Element | LiteElement> = [];
    if (elements.length > 0) {
      elements.forEach((element, index) => {
        if (element.type === 'Section' && element.display === 'tab') {
          const renderedChildren = renderFields(element.elements);
          const sectionElement = JSON.parse(JSON.stringify(element));
          sectionElement.elements = renderedChildren;
          tabbedSections.push(sectionElement);
        } else if (isTopBarField(element.type)) {
          topBarElements.push(makeFieldContainer(element, index));
        } else {
          renderedElements.push(makeFieldContainer(element, index));
        }
      });
      processTabbedSections(tabbedSections, renderedElements);

      return [
        <EditorTopBar
          key={`topBar-${topBarElements.length}`}
          formData={formData}
          record={record}
          elements={topBarElements}
          handleClose={() => handleClose()}
        />,
        ...renderedElements,
      ];
    }
    return [];
  };

  const processTabbedSections = (
    tabbedSections: Array<Element>,
    renderedElements: Array<Element>,
  ) => {
    if (tabbedSections.length > 0) {
      const key = tabbedSections.filter((section) => section.key)[0];
      renderedElements.push(<TabbedSectionGroup sections={tabbedSections} key={key} />);
    }
  };

  const makeFieldContainer = (
    element: Element | LiteElement,
    elementIndex: number,
  ) => {
    const shouldRender = element?.shouldRender || (() => true);
    if (shouldRender({ record, fields })) {
      return (
        <FieldContainer
          topBarField={isTopBarField(element.type)}
          data-testid={element.key}
          key={element.key}
        >
          {renderField(element, elementIndex)}
        </FieldContainer>
      );
    }

    return <div data-testid={element.key} key={element.key} />;
  };

  const getRef = (field: Element | LiteElement) => {
    if (field.required && errorsFields[0] === field.label) {
      return myRef;
    }

    return null;
  };

  const renderField = (field: Element, fieldIndex: number) => {
    switch (field.type) {
      case 'Section':
        if (field.display === 'inline') {
          return (
            renderFields(field.elements)
          );
        }
        return (
          <CustomAccordion sectionKey={field.key} label={field.label}>
            {renderFields(field.elements)}
          </CustomAccordion>
        );
      case 'TextField':
        return (
          <Box ref={handleRef(field)}>
            <TextField
              hidden={field.hidden}
              label={field.label}
              disabled={false}
              required={field.required}
              value={{ textValue: record.form_values[field.key] }}
              onChange={(value) => onChange(field, value.textValue)}
              withError={handleError(field.label)}
              helperText={field.description}
              rows={field.rows}
            />
          </Box>
        );
      case 'NumberField':
        return (
          <NumberField
            hidden={field.isHidden}
            label={field.label}
            required={field.isRequired}
            disabled={false}
            value={{ textValue: record.form_values[field.key] }}
            onChange={(value) => onChange(field, value.textValue)}
            min={0}
            max={0}
          />
        );
      case 'DateTimeField':
        return (
          <DateField
            hidden={field.isHidden}
            label={field.label}
            disabled={false}
            hasRRule={!!record.record_series?.rrule}
            value={{ textValue: record.form_values[field.key] ?? '' }}
            onChange={(value) => onChange(field, value.textValue)}
          />
        );
      case 'RepeatField': {
        return (
          <Collapse in={!!dateValue}>
            <Repeat
              date={dateValue}
              rrule={record.record_series?.rrule}
              onChange={(value: Record<any>['record_series'] | null) => {
                onChange(field, value);
              }}
            />
          </Collapse>
        );
      }
      case 'AddressField': {
        const validAddress = record.form_values[field.key]
          ? record.form_values[field.key]
          : ({} as Address);

        return (
          <AddressField
            hidden={field.isHidden}
            useApiPartKeys
            value={{ address: validAddress }}
            disabled={false}
            onChange={(value) => onChange(field, value.address)}
          />
        );
      }

      case 'ChoiceField':
        return (
          <ChoiceField
            hidden={field.hidden}
            multiple={false}
            label={field.label}
            emptyLabel={record.form_values[field.key]?.empty_label}
            value={{ selectedValues: record.form_values[field.key]?.choice_values || [] }}
            allowOther={false}
            disabled={false}
            onChange={({ selectedValues }: IValue) => onChange(
              field,
              { choice_values: selectedValues },
            )}
            choices={field.choices || []}
          />
        );
      case 'ClassificationField':
        return (
          <Box
            ref={getRef(field)}
            sx={{ maxHeight: 56 }}
          >
            <ClassificationsetField
              hidden={field.hidden}
              label={field.label}
              required={field.required}
              classificationSetId={field.classification_set_id}
              value={record.form_values[field.key]}
              allowOtherValue={field.allow_other}
              disabled={false}
              onChange={({ choiceValues, otherValues }: ClassificationValue) => onChange(field, {
                choice_values: choiceValues,
                other_values: otherValues,
              })}
              withError={handleError(field.label)}
              emptyLabel={field.empty_label ? `- ${field.empty_label} -` : undefined}
            />
          </Box>
        );
      case 'CombinedCreatedField':
        if (record.created_by && record.created_at) {
          const createdOnShort = new Date(record.created_at).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
          return (
            <CombinedCreatedField
              createdByName={record.created_by}
              createdOn={createdOnShort}
              createdByAvatar={`/users/${record.created_by_id}/avatar`}
              verb={terminology.createdVerb}
              sx={{ mb: '0px' }}
            />
          );
        }
        return <></>;
      case 'ProjectField':
        return (
          <ProjectField
            hidden={field.hidden}
            label={field.label}
            value={{
              label: record.project ?? '',
              value: record.project_id ?? '',
            }}
            onChange={(projectID: string | null) => {
              record.project_id = projectID;
              onChange(field, record);
            }}
            apiToken={apiToken}
            objectId={record.assigned_to_id}
            requestType={record.assigned_to_id ? 'userSelected' : ''}
            filterByUserAccess={!!record.assigned_to_id}
          />
        );
      case 'StatusField': {
        const statusIcon = (status: string) => (
          <CircleIcon sx={{ color: StatusColorMap[status], fontSize: 10 }} />
        );
        return (
          <ChoiceField
            key={`statusField-${fieldIndex}`}
            hidden={field.hidden}
            multiple={false}
            label={field.label}
            disableClearable
            value={{ selectedValues: [record.status] }}
            allowOther={false}
            disabled={false}
            onChange={({ selectedValues }: IValue) => onChange(
              field, selectedValues,
            )}
            choices={field.choices || []}
            startIcon={statusIcon}
            topBarField
          />
        );
      }
      case 'RecordLinkField': {
        const linkedRecordIDs = (record.form_values[field.key] || record.from
          || []).map(({ record_id, recordId }) => record_id || recordId).filter(Boolean);
        const isIssueLink = field.data_name === 'issues';
        return (
          <TaskLinkField
            hidden={field.hidden}
            title={field.label}
            sectionKey={field.data_name}
            taskIDs={linkedRecordIDs}
            listItem={linkedRecordView(field.data_name)}
            valuesForConditions={[]}
            onEditTask={openRecordInEditor}
            linkedRecordFormID={field.form_id}
            allowCreating={!isIssueLink}
            linkSelectedRecords={(taskIDs: any, parentRecordState: ParentRecordState) => {
              linkSelectedRecords(field.key, taskIDs, parentRecordState);
            }}
            pickerItemHandler={getLinkagePickerItem(field.data_name)}
          />
        );
      }

      case 'AssignmentField': {
        const canAssignRecords = app.globals.role.can_assign_records ?? false;

        return (
          <ITAAssignmentField
            hidden={field.hidden}
            disabled={!canAssignRecords}
            label={field.label}
            user={{
              label: record.assigned_to || '',
              value: record.assigned_to_id || '',
            }}
            onAssignmentChange={(id: string) => onChange(field, id || null)}
            apiToken={apiToken}
            objectId={record.project_id}
            requestType={record.project_id ? 'projectSelected' : ''}
          />
        );
      }
      case 'PhotoField': {
        const imagesList = record.form_values[field.key] || [];
        const typedImages = imagesList?.map(castItem);
        const photoHelper = photoFieldHelper(onChange, imagesList, field);

        const prepareImage = (image: Image) => {
          image.thumbnailURL = app?.api?.photos?.thumbnailURL(image.mediaID);
          image.onDelete = () => photoHelper.handleDelete(image.mediaID);
          image.onCaptionChange = (newCaption: string) => photoHelper.handleCaptionChange(
            image.mediaID,
            newCaption,
          );
        };

        typedImages?.map(prepareImage);

        return (
          <PhotoField
            hidden={field.isHidden}
            key={field.key}
            images={typedImages}
            editing
            onAdd={(_, uploadedFile: File) => photoHelper.handleAdd(uploadedFile)}
            disabled={field.isDisabled}
            title={field.label}
            record={record}
          />
        );
      }
      case 'DynamicField':
        if (field.key === appLinkFieldId) {
          const dynValue = new DynamicValue(
            new DynamicElement(null, field),
            record?.form_values?.[field.key] || [],
          );
          const itemHandler = getLinkagePickerItem(field.data_name);
          // If the user has already linked a record set the button title
          if (dynValue.items.length > 0 && dynValue.items[0].values.get('ccc2') !== undefined) {
            itemHandler.selectorTitle = 'Change Selected Record';
          }

          return (
            <ApplinkField
              hidden={field.hidden}
              value={dynValue}
              onSelectField={openRecordInEditor}
              onChange={(value) => {
                onChange(field, value);
              }}
              pickerItemHandler={itemHandler}
              disabled={field.disabled}
              apiToken={apiToken}
              objectId={record.assigned_to_id}
              requestType={record.assigned_to_id ? 'userSelected' : ''}
            />
          );
        }

        return (
          <ChecklistField
            hidden={field.hidden}
            value={new DynamicValue(
              new DynamicElement(null, field),
              record?.form_values?.[field.key] || [],
            )}
            onChange={(value: DynamicValue) => {
              onChange(field, value.toJSON());
            }}
          />
        );
      case 'LocationField':
        const defaultExtents = app.preferences.issueEditorMapExtents;

        const setMapExtents = (key: string) => {
          if (key === '7ds7') {
            return {
              ...defaultExtents,
              latitude: record.form_values['7ds7']?.latitude || 0,
              longitude: record.form_values['7ds7']?.longitude || 0,
              zoom: 14,
            };
          }
          return {
            ...defaultExtents,
            latitude: record.latitude,
            longitude: record.longitude,
            zoom: 14,
          };
        };

        const handleLocationChange = (latitude: number, longitude: number, address?: string) => {
          if (field.key === '7ds7') {
            onChange(field, { latitude, longitude, address });
          } else {
            record.latitude = latitude;
            record.longitude = longitude;
            onChange(field, record);
          }
        };

        return (
          <CustomAccordion sectionKey={field.key} label={field.label}>
            <LocationField
              mapExtents={setMapExtents(field.key)}
              saveMapExtents={(extents) => {
                app.preferences.setIssueEditorMapExtents(extents);
              }}
              onLocationChange={handleLocationChange}
            />
          </CustomAccordion>
        );
      default:
        return <></>;
    }
  };

  return renderFields(fields);
};

export default withDataEvents(EditorFields);
